import React from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

import map from 'lodash/map'
import slice from 'lodash/slice'
import size from 'lodash/size'

import { DesktopSlider, MerchantGridCard } from 'Components/Blocks'

import { Box } from 'Components/UI'

import { useBaseTheme } from 'Hooks'
import {
  DesktopView,
  FeaturedMerchantsInnerContainer,
  FeaturedMerchantsMobileContainer,
  FeaturedMerchantsMobileSlider,
} from './styles'

function TopOffersSliders({ topOffers, sliderSettings }) {
  const { isPortableDevice } = useBaseTheme()

  return (
    <>
      {!isPortableDevice && (
        <DesktopView>
          {size(topOffers) === 4 || size(topOffers) === 8 ? (
            <FeaturedMerchantsInnerContainer>
              {map(slice(topOffers, 0, 8), merchant => (
                <LazyLoad key={merchant.token} once>
                  <MerchantGridCard goToPromotion merchant={merchant} />
                </LazyLoad>
              ))}
            </FeaturedMerchantsInnerContainer>
          ) : (
            <DesktopSlider>
              {map(topOffers, merchant => (
                <Box key={merchant.token} px="5px" py="8px">
                  <MerchantGridCard goToPromotion merchant={merchant} />
                </Box>
              ))}
            </DesktopSlider>
          )}
        </DesktopView>
      )}

      {isPortableDevice && (
        <FeaturedMerchantsMobileContainer>
          <LazyLoad height="400px" once>
            <FeaturedMerchantsMobileSlider {...sliderSettings}>
              {map(slice(topOffers, 0, 8), merchant => (
                <Box key={merchant.token} px="5px" py="8px">
                  <MerchantGridCard goToPromotion merchant={merchant} />
                </Box>
              ))}
            </FeaturedMerchantsMobileSlider>
          </LazyLoad>
        </FeaturedMerchantsMobileContainer>
      )}
    </>
  )
}

TopOffersSliders.propTypes = {
  sliderSettings: PropTypes.object.isRequired,
  topOffers: PropTypes.array.isRequired,
}

export default TopOffersSliders
